module.exports = __webpack_public_path__ + "img/group-6.cc681c38.svg";